import React, { useId } from 'react';
import { TrendingUp, Coffee } from 'lucide-react';
import '../competition-r41.css';

export default function MatchTypeSelector({ value, onChange, boardSize, disabled = false, rating, label = 'Maç türü' }) {
  const hintId = useId();
  return <div className="match-type-r41">
    <div className="setup-label-r41"><span>Oyun modu</span>{rating != null && <span className="rating-chip-r41" aria-label={`Oyuncu derecen: ${rating}`}><TrendingUp size={13} aria-hidden="true"/>{rating}</span>}</div>
    <div className="match-type-segments-r41" role="group" aria-label={label} aria-describedby={hintId}>
      {[['rated', 'Rated', TrendingUp], ['casual', 'Casual', Coffee]].map(([key, text, Icon]) => <button key={key} type="button" aria-pressed={value === key} disabled={disabled || (key === 'rated' && boardSize === 8)} onClick={() => onChange(key)}><Icon size={17} aria-hidden="true"/><span>{text}</span></button>)}
    </div>
    <p id={hintId} className="match-type-hint-r41">{boardSize === 8 ? '8×8 yalnız Casual oynanır; oyuncu dereceni etkilemez.' : value === 'rated' ? 'Oyuncu dereceni etkiler.' : 'Oyuncu dereceni etkilemez.'}</p>
  </div>;
}
